import i18n from "i18next";

import type { LateralLocation } from "api/schemas/shared/Treatment";

export function translateLateralLocation(lateralLocation: LateralLocation): string {
  switch (lateralLocation) {
    case "left":
      return i18n.t("patients.lateral_location.left");
    case "right":
      return i18n.t("patients.lateral_location.right");
    case "undefined":
      return "";
    default:
      return "";
  }
}
